import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxSpinnerModule } from 'ngx-spinner';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { UserManagementService } from '../authenticate/usermanagement.service';
import { InfoAlertService } from './services/infoalert.service';
import { AuthService } from './services/auth.service';
import { ContentSplitterModule } from './content-splitter';
import { JwtInterceptor } from './services/jwtinterceptor.service';
import { ConnectionFailurePopUpComponent } from './connectionFailure-pop-up/connectionFailurepopup.component';
import { ApiErrorPopUpComponent } from './api-error-pop-up/api-error-pop-up.component';
import { ConfirmModalComponent } from './confirmmodal/confirmModal.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/locales/', '.json');
}

@NgModule({
  imports: [
    CommonModule,
    NgxSpinnerModule,
    BrowserAnimationsModule,
    ContentSplitterModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  exports: [
    ConnectionFailurePopUpComponent,
    ApiErrorPopUpComponent,
    ConfirmModalComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    ConnectionFailurePopUpComponent,
    ApiErrorPopUpComponent,
    ConfirmModalComponent
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true
    },
    UserManagementService,
    InfoAlertService,
    AuthService
  ],
})
export class SharedModule { }
